module.exports = __webpack_public_path__ + "static/media/breakApart-dark.491bfacc.svg";